(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mismatch-photo-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('mismatch-photo-gallery')){customElements.define('mismatch-photo-gallery',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.addEventListener('click',event=>{const button=event.target.closest('button[data-choice]');if(!button||!this.contains(button))return;const choice=button.dataset.choice;this.querySelectorAll('[data-photo]').forEach(image=>{image.hidden=image.dataset.photo!==choice});this.querySelectorAll('[data-choice]').forEach(control=>{control.setAttribute('aria-pressed',String(control.dataset.choice===choice))})})}})}
  } catch(e) { console.error(e); }
})();

})();
